import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';

@Component
export default class CatalogBoolFilterComponent extends Vue {

    @prop()
    private value: CatalogFilterField;


    get selectedValueLabel() {
        if (this.value.values.length === 1) {
            return this.value.values[0];
        }

        return `Несколько (${this.value.values.length})`;
    }

    clear() {
        this.value.values = [];
    }

    get changed() {
        return !!this.value.values;
    }

    get fieldKey() {
        return `filter__${this.value.code}`;
    }
}
